import logo from "./png/logo.png"
import profile from "./png/profile.png"
import background from "./jpg/background.jpg"
export const Images = {
    logo,
    profile,
    background
}